import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9d193eec")

_pushScopeId("data-v-9d193eec")
const _hoisted_1 = {
  key: 0,
  class: "text-center text-gray-500 font-light py-4"
}
const _hoisted_2 = {
  key: 1,
  style: {"max-width":"100%","overflow-x":"scroll","padding-bottom":"12px"}
}
const _hoisted_3 = { style: {"min-width":"100%"} }
const _hoisted_4 = {
  key: 0,
  class: "bg-primary text-white"
}
const _hoisted_5 = {
  key: 1,
  class: "bg-primary text-white"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "geo" }
const _hoisted_8 = { class: "geo-item" }
const _hoisted_9 = {
  key: 1,
  class: "last-td select-none"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")

  return (_ctx.items.length === 0)
    ? (_openBlock(), _createBlock("p", _hoisted_1, _toDisplayString(_ctx.emptyMessage), 1))
    : (_openBlock(), _createBlock("div", _hoisted_2, [
        _createVNode("table", _hoisted_3, [
          _createVNode("tr", null, [
            (_ctx.geo)
              ? (_openBlock(), _createBlock("th", _hoisted_4, "GEO"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headers, (header, i) => {
              return (_openBlock(), _createBlock("th", {
                key: 'header' + i,
                class: {'bg-primary text-white':true, 'hidden': header.hidden }
              }, _toDisplayString(header.label), 3))
            }), 128)),
            (_ctx.clickable && _ctx.actions.length > 0)
              ? (_openBlock(), _createBlock("th", _hoisted_5, "Acciones"))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
            return (_openBlock(), _createBlock("tr", {
              key: 'item'+ i + item.uid,
              class: {'cursor-pointer': _ctx.clickable, 'pointer-events-none': !_ctx.clickable, 'tr-hoverable bg-white': true}
            }, [
              (_ctx.geo)
                ? (_openBlock(), _createBlock("td", _hoisted_6, [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, [
                        (!item.data.img)
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.pickFile(item.uid)),
                              class: "icon-container"
                            }, [
                              _createVNode(_component_fa_icon, {
                                icon: ['fa', 'image'],
                                size: "1x"
                              })
                            ], 8, ["onClick"]))
                          : (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: "image-icon-preview",
                              onClick: ($event: any) => (_ctx.pickFile(item.uid)),
                              style: { backgroundImage: `url(${_ctx.rumaImageUrl(item.uid)})`}
                            }, null, 12, ["onClick"]))
                      ]),
                      _createVNode("div", {
                        class: {
            'geo-item': true,
            'no-geo-item': !item.data.geo.lat || !item.data.geo.lon,
            'opacity-50': !item.data.geo.lat || !item.data.geo.lon,
          }
                      }, [
                        _createVNode("div", {
                          onClick: ($event: any) => (_ctx.showMap(item.data)),
                          class: "icon-container"
                        }, [
                          _createVNode(_component_fa_icon, {
                            icon: ['fa', 'map-marker-alt'],
                            size: "1x"
                          })
                        ], 8, ["onClick"])
                      ], 2)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headers, (h, i) => {
                return (_openBlock(), _createBlock("td", {
                  key: 'subheader' + i,
                  class: { 'hidden': h.hidden },
                  onClick: ($event: any) => (_ctx.selectItem(item))
                }, _toDisplayString(_ctx.formatted(item.data[h.key], h.format)), 11, ["onClick"]))
              }), 128)),
              (_ctx.clickable && _ctx.actions.length > 0)
                ? (_openBlock(), _createBlock("td", _hoisted_9, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.actions, (action, a) => {
                      return (_openBlock(), _createBlock("span", {
                        class: 'table-action ' + action.class,
                        key: action.label + a,
                        onClick: ($event: any) => (action.cb(i))
                      }, _toDisplayString(action.label), 11, ["onClick"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]),
        _createVNode("input", {
          id: "fileinput",
          type: "file",
          ref: "fileRef",
          style: {"display":"none"},
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.charge && _ctx.charge(...args))),
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFilePicked && _ctx.onFilePicked(...args))),
          accept: "image/*"
        }, null, 544)
      ]))
})